// import RedisService from './redis';
import { adsTrcking } from "@/types/common";
import { getApiBaseUrl, buildHeaders } from "@/utils/getApiBaseUrl";

export const adsService = {
  generatAdsSessions: async (slug: string,subscriber_id?:string) => {
    try {
      const token = localStorage.getItem('accessToken') ?? ""
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/ads/ads-session-generate?api_slug=${slug}`,
        {
          method: "POST",
          headers: buildHeaders(token,'generatAdsSessions',''),
          body: JSON.stringify({ subscriber_id:subscriber_id }),
          cache:'no-store',
          next: { revalidate: 0 }, // No cache
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("generatAdsSessions Error data:", error);
      return null;
    }
  },

  adsTracking: async (formData: adsTrcking) => {
    try {
      const token = localStorage.getItem('accessToken') ?? ""
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/ads/ads-session-track`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...buildHeaders(token,'adsTracking',''),
          },
          body: JSON.stringify(formData),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error submitting Ads Tracking Data:", error);
      throw error;
    }
  },

  getAdsJs: async () => {
    try {
      // console.log(
      //   getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL,
      //   "ads trigger"
      // );
      // const response = await fetch(
      //   `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/ads/ads.js?slug=home-page`
      // );
      // console.log(response, "responsemr");
      // const data = await response.json();
      // console.log(data.data, "responsemr");
      // return data.data;
    } catch (error) {
      console.error("getAdsJs Error fetching Article data:", error);
      return null;
    }
  },
};
